var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 45,
        "min-height": 85,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v(_vm._s(_vm.smsModalHeader))]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _vm.isSendSmsModalActive
            ? _c("sms-send", {
                ref: "smsSend",
                attrs: { active: _vm.isSendSmsModalActive },
                on: {
                  "update:active": function ($event) {
                    _vm.isSendSmsModalActive = $event
                  },
                  "smsdetails-entered": _vm.smsDetailsEntered,
                },
                model: {
                  value: _vm.smsDetails,
                  callback: function ($$v) {
                    _vm.smsDetails = $$v
                  },
                  expression: "smsDetails",
                },
              })
            : _vm._e(),
          _vm.isSmsMessageModalActive
            ? _c("sms-message", {
                ref: "smsMessage",
                attrs: {
                  active: _vm.isSmsMessageModalActive,
                  "enable-save": _vm.enableSave,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isSmsMessageModalActive = $event
                  },
                  back: _vm.backToSmsSend,
                  "save-button": _vm.setEnableSave,
                  close: _vm.close,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            style: `width: 100%; display: flex; justify-content: space-between;`,
          },
          [
            _c(
              "div",
              { staticStyle: { width: "100%" }, attrs: { align: "right" } },
              [
                _vm.isSendSms
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary tooltip",
                          attrs: { "data-tooltip": "Edit message template" },
                          on: {
                            click: function ($event) {
                              return _vm.editTemplate()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-pencil mdi-18px" }),
                          ]),
                          _c("span", [_vm._v("Edit Template")]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button is-success tooltip",
                          attrs: {
                            disabled: !_vm.enableSend,
                            "data-tooltip": "Send",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.send()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-send mdi-18px" }),
                          ]),
                          _c("span", [_vm._v("Send")]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button tooltip",
                          attrs: { "data-tooltip": "Close" },
                          on: {
                            click: function ($event) {
                              return _vm.close(true)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-check mdi-18px" }),
                          ]),
                          _c("span", [_vm._v("Close")]),
                        ]
                      ),
                    ])
                  : _c("div", [
                      _vm.enableSave
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-success tooltip",
                              attrs: { "data-tooltip": "Save changes" },
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-content-save mdi-18px",
                                }),
                              ]),
                              _c("span", [_vm._v("Save")]),
                            ]
                          )
                        : _vm._e(),
                      _vm.enableSave
                        ? _c(
                            "button",
                            {
                              staticClass: "button tooltip",
                              attrs: { "data-tooltip": "Cancel changes" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancel()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-close mdi-18px",
                                }),
                              ]),
                              _c("span", [_vm._v("Cancel")]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.enableSave
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-primary tooltip",
                              attrs: {
                                "data-tooltip": "Add new message template",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.add()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-plus mdi-18px",
                                }),
                              ]),
                              _c("span", [_vm._v("New Message")]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "button tooltip",
                          attrs: { "data-tooltip": "Back to Send SMS" },
                          on: { click: _vm.back },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", {
                              staticClass: "mdi mdi-arrow-left-bold mdi-18px",
                            }),
                          ]),
                          _c("span", [_vm._v("Back")]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button tooltip",
                          attrs: { "data-tooltip": "Close" },
                          on: {
                            click: function ($event) {
                              return _vm.close(false)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-check mdi-18px" }),
                          ]),
                          _c("span", [_vm._v("Close")]),
                        ]
                      ),
                    ]),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }